import * as cpfCpnj from 'cpf-cnpj-validator'

export const validateCpf = (cpf, setCpfInvalid) => {
  if (cpf !== '' && cpf !== '___.___.___-__') {
    const valid = cpfCpnj.cpf.isValid(cpf)
    !valid ? setCpfInvalid(true) : setCpfInvalid(false)
  }
}
